import React from "react";
import { AppBar, Box, Dialog, Tooltip, IconButton, DialogContent, DialogTitle, Divider, LinearProgress, Tab, Tabs, TextField, Toolbar, Typography, Accordion, AccordionSummary, AccordionDetails, Select, Grid, Chip, InputBase, makeStyles, Button, Menu, MenuItem, Paper, FormControl, FormHelperText } from "@material-ui/core";
import { MatIconService } from "../../../shared/services/theme/matIconService";
import LayoutService from "../../../shared/services/layoutService";
import { CrudAction } from "../../../shared/types/enums";
import { DataService, SubscriptionArray } from "../../../shared/services/dataService";
import ProfileAdvancedSearchComponent from "./profile-advanced-search/profileAdvancedSearchComponent";
import TransactionAdvancedSearchComponent from "./transaction-advanced-search/transactionAdvancedSearchComponent";
import AgreementAdvancedSearchComponent from "./agreement-advanced-search/agreementAdvancedSearchComponent";
//import AdvancedSearchComponent from "./advanced-search/advancedSearchComponent";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { FILTER_TYPE, ResultStatus } from "../../../shared/types/enums";
import { textFilterCriteria, lovFilterCriteria, valueFilterCriteria, dateFilterCriteria } from "../../../shared/types/constants";
import { Formik } from "formik";
import * as Yup from "yup";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import MatSpecService from "../../../shared/services/theme/matSpecService";
import AdvancedSearchContainerService from "./advancedSearchContainerService";
import { AuthContext } from "../../../shared/store/authProvider";
import DialogErrorFragmentComponent from "../../../shared/components/page/dialogErrorFragmentComponent";
import PageLoadingComponent from "../../../shared/components/page/pageLoadingComponent";


class AdvancedSearchComponent extends React.Component {
  static contextType = AuthContext;
  oSubscriptions = new SubscriptionArray();

  constructor(props) {
    super(props);
    this.filterWithErrorValue = [5, 11, 118, 35, 36];

    this.state = {
      selectedTabIndex: 0,
      advancedSearchExpanded: true,
      filterCriteria: [],
      savedFilterData: [],
      searchValue: "",
      errorInfo: null,
      fetchResult: ResultStatus.NOT_LOADED,
    };
  }

  componentWillUnmount() {
    this.setState({
      advancedSearchExpanded: false
    });
  }

  componentDidMount() {
    this.fetchFilterData();
  }

  fetchFilterData = (_ignoreCache = false) => {
    this.oSubscriptions.cancelAll();
    this.setState({ fetchResult: ResultStatus.LOADING });
    // save the subscription object
    this.oSubscriptions.add(
      AdvancedSearchContainerService.fetchFilterData(this.context.user.tenantId)
        .subscribe(
          (data) => {
            if (data) {
              data["filterFields"].forEach(x => { x.isSelected = false; });
              let filterFields = data["filterFields"];

              let operators = data["operators"];

              let lovFilters = data["lovFilters"];
              this.setState({
                fetchResult: ResultStatus.LOADED,
                filterFields: filterFields,
                operators: operators,
                lovFilters: lovFilters,
              }, () => {
                //this.handleFieldSelectChange(this.state.filterFields[0]?.fieldName);
              });
              //TODO : add isSelected flag for hiding already selected filters
            }
            else {
              this.setState({
                fetchResult: ResultStatus.ERROR,
                errorInfo: "Error occurred while fetching Advanced search filters"
              });
            }
          },
          (error) => {
            this.setState({
              fetchResult: ResultStatus.ERROR,
              errorInfo: "Error occurred while fetching Advanced search filters. " + error.message
            });
          }
        )
    );
  }

  onClose = (_reloadRequired = false) => {
    this.setState({
      advancedSearchExpanded: false,
      savedFilterData: [],
      searchValue: ""
    }, () => this.props.close());
  }

  _changeTab = (event, _newTabIndex) => {
    this.setState({
      selectedTabIndex: _newTabIndex,
      isReadOnly: true // on tab change make it readonly
    });
  }

  handleChange = (panel) => (event, isExpanded) => {
    this.setState({
      advancedSearchExpanded: isExpanded
    });
  };

  handleDeleteChip = (chipToDelete) => () => {
    this.setState({
      savedFilterData: this.state.savedFilterData.filter((filter) => filter.fieldAliasName !== chipToDelete.fieldAliasName)
    });
  }

  clearAllChips = () => {
    this.setState({ savedFilterData: [] });
  }

  async handleFieldSelectChange(value) {
    let filterType = this.state.filterFields.find(f => f.fieldName == value)?.fieldTypeID;
    let filterCriteria;
    switch (filterType) {
      case FILTER_TYPE.TEXT:
      default:
        filterCriteria = textFilterCriteria;
        break;
      case FILTER_TYPE.LOV:
        filterCriteria = lovFilterCriteria;
        break;
      case FILTER_TYPE.NUMERIC:
        filterCriteria = valueFilterCriteria;
        break;
      case FILTER_TYPE.DATE:
        filterCriteria = dateFilterCriteria;
        break;
    }
    await this.formikProps.setFieldValue('filterCriteria', filterCriteria[0].lovId, false);
    //await this.formikProps.setFieldTouched('filterCriteria', true, false);
    //this.formikProps.validateField('filterCriteria');

    this.setState({
      filterCriteria: filterCriteria
    });
  }

  async handleCriteriaSelectChange(value) {
    // await this.formikProps.setFieldValue('filterCriteria', value, false);
    // await this.formikProps.setFieldTouched('filterCriteria', true, false);
    // this.formikProps.validateField('filterCriteria');
  }

  handleLOVValueChange(newValues) {
  }

  addFilter = async (fieldName, criteria, value) => {//TODO
    if (!this.formikProps.isSubmitting && this.formikProps.isValid) {
      await this.validationSchema.validate(this.formikProps.values, { abortEarly: false })
        .then((x) => {
          let selectedFilter = this.state.filterFields.find(f => f.fieldName == fieldName);

          let savedFilterData = {
            fieldId: selectedFilter?.fieldID,
            fieldText: fieldName,
            fieldAliasName: selectedFilter?.fieldAliasName,
            fieldTypeID: selectedFilter?.fieldTypeID,
            criteria: criteria,
            value: value,
          };

          this.setState({
            savedFilterData: this.state.savedFilterData.concat(savedFilterData)
          }, () => this.formikProps.resetForm());
        })
        .catch((errorObj) => {
          console.log(errorObj.message);
          if (errorObj.inner) {
            errorObj.inner.forEach(err => {
              this.formikProps.setFieldError(err.path, err.message);
            });
          }
        });
    }
  }

  constructSearchString = () => {
    let searchValue = "";

    searchValue = this.state.savedFilterData.map(data => {
      let operator;
      switch (data.criteria) {
        case "equals":
        case "notequals":

          //Handle Null and Error filter values
          if (data.fieldTypeID == FILTER_TYPE.LOV) {//sample string: @SerachString='Country IN ('Belgium', 'United States') OR Country is NULL' 
            let selectedValues = data.value.split(",");
            const nullStr = "'Null'";
            const errorStr = "'Error/Warning'";//sample string: if 'PURPOSE_FLAG='1'

            const hasNullValue = selectedValues.some(x => x == nullStr);
            const hasErrorValue = selectedValues.some(x => x == errorStr);

            let clause = '';
            if (selectedValues.some(x => x != nullStr && x != errorStr)) {
              operator = data.criteria == "equals" ? " IN " : " NOT IN ";
              clause = `${data.fieldAliasName}${operator}(${selectedValues.filter(x => x != nullStr && x != errorStr).join()})`;
            }
            if (hasNullValue && hasErrorValue) {
              let addClause = `${data.fieldAliasName}_FLAG${(data.criteria == "equals") ? "=" : "<>"}1 OR ${data.fieldAliasName} ${(data.criteria == "equals") ? "IS NULL" : "IS NOT NULL"}`
              clause += selectedValues.some(x => x != errorStr && x != nullStr) ? ` OR ${addClause}` : `${addClause}`;
            } else if (hasNullValue) {
              let addClause = `${data.fieldAliasName} ${(data.criteria == "equals") ? "IS NULL" : "IS NOT NULL"}`;
              clause += selectedValues.some(x => x != nullStr) ? ` OR ${addClause}` : `${addClause}`;
            } else if (hasErrorValue) {
              let addClause = `${data.fieldAliasName}_FLAG${(data.criteria == "equals") ? "=" : "<>"}1`;
              clause += selectedValues.some(x => x != errorStr) ? ` OR ${addClause}` : `${addClause}`;
            }
            return clause;
          }


          if (data.fieldTypeID == FILTER_TYPE.TEXT) {
            if (data.value.indexOf(",") !== -1) { //Handle comma separated values
              operator = data.criteria == "equals" ? " IN " : " NOT IN ";
              let clause = `${data.fieldAliasName}${operator}(${data.value})`;
              return clause;
            }
            operator = data.criteria == "equals" ? "=" : "<>";
            return `${data.fieldAliasName}${operator}N'${data.value}'`;
          }

          operator = data.criteria == "equals" ? "=" : "<>";
          break;
        case "lessthan":
          operator = "<";
          break;
        case "greaterthan":
          operator = ">";
          break;
        case "between":
          operator = " BETWEEN ";
          return `${data.fieldAliasName}${operator}${data.value}`;
        //break;
        case "contains":
          operator = " LIKE ";
          return `${data.fieldAliasName}${operator}N'%${data.value}%'`;
        //break;
        default:
          operator = "=";
      }
      return `${data.fieldAliasName}${operator}'${data.value}'`;
    }).join(" AND ");
    return searchValue;
  }

  applyFilter = () => {
    let searchedValue = this.constructSearchString();
    this.setState({
      searchValue: searchedValue
    }, () => {
      AdvancedSearchContainerService.advancedSearchSubject.next('true');
    });
  }

  getFilterValueContent(_formikProps, _classes) {
    this.formikProps = _formikProps;
    let filterType = this.state.filterFields.some(f => f.fieldName == _formikProps.values['filterFieldId']) ?
      this.state.filterFields.find(f => f.fieldName == _formikProps.values['filterFieldId']).fieldTypeID : FILTER_TYPE.TEXT;
    let selectedCriteriaValue = _formikProps.values['filterCriteria'] ? _formikProps.values['filterCriteria'] :
      this.state.filterCriteria[0];

    if (filterType === FILTER_TYPE.DATE) {
      return (
        <>
          <Grid item xs={12} sm={2}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <DatePicker {...LayoutService.getDateProps(false, _classes, _formikProps, "startDate", "Start Date", true)} format="yyyy-MM-dd" style={{ minWidth: "90%" }} />
            </MuiPickersUtilsProvider>
          </Grid>
          <Grid item xs={12} sm={2}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <DatePicker {...LayoutService.getDateProps(false, _classes, _formikProps, "endDate", "End Date", true)} format="yyyy-MM-dd" style={{ minWidth: "90%" }} />
            </MuiPickersUtilsProvider>
          </Grid>
          <Grid item xs={12} sm={2} style={{ marginTop: "10px" }}>
            <Tooltip enterDelay={MatSpecService.tooltipEnterDelay} title="Add Filter" placement="bottom" arrow>
              <IconButton onClick={() => {
                this.addFilter(_formikProps.values['filterFieldId'], _formikProps.values['filterCriteria'], `'${DataService.getDateFromDateTimeStamp(_formikProps.values['startDate']) + "' and '" + DataService.getDateFromDateTimeStamp(_formikProps.values['endDate'])}'`)
              }} color="primary">{MatIconService.ADD_CIRCLE_OUTLINE}</IconButton>
            </Tooltip>
          </Grid>
        </>
      );
    } else if (filterType === FILTER_TYPE.LOV) {
      let selectedFilterFieldID = this.state.filterFields.find(f => f.fieldName == _formikProps.values['filterFieldId'])?.fieldID;
      return (<>
        {this.filterWithErrorValue.includes(selectedFilterFieldID) ?
          <Grid item xs={12} sm={4} style={{ marginTop: "-10px" }}>
            {LayoutService.getChipSelect(false, _classes, _formikProps, "filterLOVValue", "Filter Value", [{ fieldID: selectedFilterFieldID, lovKey: "Error/Warning", lovid: null }, { fieldID: selectedFilterFieldID, lovKey: "Null", lovid: 0 }, ...[this.state.lovFilters.filter(f => f.fieldID == selectedFilterFieldID)][0]].sort((a, b) => a.lovKey.localeCompare(b.lovKey)), "lovid", "lovKey", this.handleLOVValueChange, "98%")}
          </Grid>
          :
          <Grid item xs={12} sm={4} style={{ marginTop: "-10px" }}>
            {LayoutService.getChipSelect(false, _classes, _formikProps, "filterLOVValue", "Filter Value", [{ fieldID: selectedFilterFieldID, lovKey: "Null", lovid: 0 }, ...[this.state.lovFilters.filter(f => f.fieldID == selectedFilterFieldID)][0]].sort((a, b) => a.lovKey.localeCompare(b.lovKey)), "lovid", "lovKey", this.handleLOVValueChange, "98%")}
          </Grid>}
        <Grid item xs={12} sm={2} style={{ marginTop: "10px" }}>
          <Tooltip enterDelay={MatSpecService.tooltipEnterDelay} title="Add Filter" placement="bottom" arrow>
            <IconButton onClick={() => {
              this.addFilter(_formikProps.values['filterFieldId'], _formikProps.values['filterCriteria'], "'" + _formikProps.values["filterLOVValue"].map(lov => lov.lovKey).join("','") + "'")
            }} color="primary">{MatIconService.ADD_CIRCLE_OUTLINE}</IconButton>
          </Tooltip>
        </Grid>
      </>);
    } else {
      if (selectedCriteriaValue == "between") {
        //value type with range selected
        return (
          <>
            <Grid item xs={12} sm={2}>
              <TextField type="number" {...LayoutService.getInputProps(false, _classes, _formikProps, "filterRangeValue1", "From", true)} style={{ minWidth: "80%" }} />
            </Grid>
            <Grid item xs={12} sm={2}>
              <TextField type="number" {...LayoutService.getInputProps(false, _classes, _formikProps, "filterRangeValue2", "To", true)} style={{ minWidth: "80%" }} />
            </Grid>
            <Grid item xs={12} sm={2} style={{ marginTop: "10px" }}>
              <Tooltip enterDelay={MatSpecService.tooltipEnterDelay} title="Add Filter" placement="bottom" arrow>
                <IconButton onClick={() => {
                  this.addFilter(_formikProps.values['filterFieldId'], _formikProps.values['filterCriteria'], `'${_formikProps.values['filterRangeValue1'] + "' and '" + _formikProps.values['filterRangeValue2']}'`)
                }} color="primary">{MatIconService.ADD_CIRCLE_OUTLINE}</IconButton>
              </Tooltip>
            </Grid>
          </>
        );
      }
      return (
        <React.Fragment>
          <Grid item xs={12} sm={4}>
            <TextField error={_formikProps.values["filterValue"] == ''} helperText={_formikProps.values["filterValue"] == '' ? 'Enter a Filter Value!' : ' '} {...LayoutService.getInputProps(false, _classes, _formikProps, "filterValue", "Filter Value", true)} style={{ minWidth: "80%" }} />
          </Grid>
          <Grid item xs={12} sm={2} style={{ marginTop: "10px" }}>
            <Tooltip enterDelay={MatSpecService.tooltipEnterDelay} title="Add Filter" placement="bottom" arrow>
              <IconButton onClick={() => {
                let modValues = _formikProps.values['filterValue'];
                let selectedValues = _formikProps.values['filterValue'].split(",");
                if (selectedValues && selectedValues.length > 1) {
                  modValues = "'" + selectedValues.join("','") + "'";
                }
                this.addFilter(_formikProps.values['filterFieldId'], _formikProps.values['filterCriteria'], modValues);
              }} color="primary">{MatIconService.ADD_CIRCLE_OUTLINE}</IconButton>
            </Tooltip>
          </Grid>
        </React.Fragment>
      );
    }
  }

  // formik
  getInitialValues() {
    return {
      filterFieldId: null,
      filterCriteria: '',
      startDate: new Date(),
      endDate: new Date(),
      //filterLOVValue: '',
      filterValue: '',
      filterRangeValue1: '',
      filterRangeValue2: ''
    };
  }

  validationSchema = Yup.object().shape({});
  getValidationSchema() {
    let filterSchema = Yup.object().shape({
      filterFieldId: Yup.string().required("Select a Filter Name").nullable(true).min(1, "Select a Filter Name"), //Yup.number().nullable(true)
      filterCriteria: Yup.string().required("Select a Filter Criteria").nullable(true).min(1, "Select a Filter Criteria"),
      // //filterLOVValue: Yup.string().nullable(true).min(1, "Select a Filter Value"),
    });

    if (this.formikProps && this.formikProps.values['filterFieldId']) {
      let filterType = this.state.filterFields.find(f => f.fieldName == this.formikProps.values['filterFieldId']).fieldTypeID;
      let filterDynamicSchema = Yup.object().shape({});
      if (filterType === FILTER_TYPE.DATE) {
        filterDynamicSchema = Yup.object().shape({
          startDate: Yup.date().required("Select a Start Date").nullable(true).min("1/1/2000", "On or after 1/1/2000").max("1/1/2099", "On or before 1/1/2099"),
          endDate: Yup.date().required("Select an End Date").nullable(true).min("1/1/2000", "On or after 1/1/2000").max("1/1/2099", "On or before 1/1/2099"),
        });
      } else if (filterType === FILTER_TYPE.LOV) {
        filterDynamicSchema = Yup.object().shape({
          filterLOVValue: Yup.string().required("Select a Filter Value").nullable(true).min(1, "Select a Filter Value"),
        });
      } else {
        // if (this.formikProps.values['filterCriteria'] == "between") {
        //   filterDynamicSchema = Yup.object().shape({
        //     filterRangeValue1: Yup.string().required("Enter a Filter Value").nullable(true).max(256, "Must be 256 characters or less"),
        //     filterRangeValue2: Yup.string().required("Enter a Filter Value").nullable(true).max(256, "Must be 256 characters or less")
        //   });
        // } else {
        //   filterDynamicSchema = Yup.object().shape({
        //     filterValue: Yup.string().required("Enter a Filter Value").nullable(true).max(256, "Must be 256 characters or less")
        //   });
        // }
      }

      this.validationSchema = filterSchema.concat(filterDynamicSchema);
    } else this.validationSchema = filterSchema;
    return this.validationSchema;
  }

  render() {
    const { classes } = this.props;
    switch (this.state.fetchResult) {
      case ResultStatus.NOT_LOADED:
      case ResultStatus.LOADING:
        return <PageLoadingComponent small classes={classes} label="Loading Advanced Search" />;
      case ResultStatus.LOADED:
      case ResultStatus.SUCCESS:
        return (
          <>
            {/* DialogTitle */}
            <React.Fragment>
              <DialogTitle disableTypography id="dialogTitle">
                <AppBar position="static">
                  <Toolbar>
                    <Typography variant="h6" className={classes.root}>Advanced Search</Typography>
                    {LayoutService.getIconButton(false, MatIconService.CANCEL, "Close", () => { this.onClose(false) }, "secondary", "keyActionCancel")}
                  </Toolbar>
                </AppBar>
              </DialogTitle>
              {/* DialogContent */}
              <DialogContent>
                <Accordion expanded={this.state.advancedSearchExpanded} onChange={this.handleChange('panel')}>
                  {/* <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel-content"
                    id="panel-header">
                    <Typography className={classes.heading} style={{
                      flexBasis: '33.33%',
                      flexShrink: 0
                    }}>Advanced Search</Typography>
                    <Typography className={classes.secondaryHeading}>Add multiple filters to filter further</Typography>
                  </AccordionSummary> */}
                  <AccordionDetails>
                    <Formik initialValues={this.getInitialValues()} validationSchema={this.getValidationSchema()}
                      validationSchemaOptions={{ showMultipleFieldErrors: true }}>
                      {(fProps) => (
                        <form style={{ width: "100%" }}>
                          <Grid container direction="row" alignItems="center" style={{ paddingBottom: "10px", }}>
                            <Grid container spacing={1} style={{ minHeight: "10vh" }}>
                              <Grid item xs={12} sm={3} >
                                {LayoutService.getDropDown(false, classes.dialogControl, classes.menuPaper, fProps, this.validationSchema, "filterFieldId", "Filter Name",
                                  this.state.filterFields, "fieldName", "fieldName", null, false, "98%", (_formikProps, _newValue) => {
                                    this.handleFieldSelectChange(_newValue);
                                  }
                                )}
                              </Grid>
                              <Grid item xs={12} sm={3}>
                                {LayoutService.getDropDown(false, classes.dialogControl, classes.menuPaper, fProps, this.validationSchema, "filterCriteria", "Criteria",
                                  this.state.filterCriteria, "lovId", "lovKey", null, false, "98%", (_formikProps, _newValue) => { this.handleCriteriaSelectChange(_newValue); }
                                )}
                              </Grid>
                              {this.getFilterValueContent(fProps, classes)}
                            </Grid>
                            <Grid container spacing={1}>
                              <Paper component="ul" square="true" elevation="0" style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', listStyle: 'none', padding: '4px', boxShadow: 'none', alignItems: 'center' }}>
                                {this.state.savedFilterData.map((data) => {
                                  return (<li key={data.key}>
                                    <Chip variant="outlined" label={
                                      <span>
                                        <span style={{ color: 'black' }}>{data.fieldText}</span>
                                        <span style={{ color: 'gray' }}> {data.criteria}</span>
                                        <span style={{ color: 'black' }}> {data.value}</span>
                                      </span>} onDelete={this.handleDeleteChip(data)} style={{ margin: '4px' }} />
                                  </li>
                                  );
                                })}
                                {this.state.savedFilterData.length > 0 ?
                                  <Tooltip enterDelay={MatSpecService.tooltipEnterDelay} title="Clear All" placement="bottom" arrow>
                                    <IconButton onClick={() => { this.clearAllChips() }} color="inherit">{MatIconService.CLOSE}</IconButton>
                                  </Tooltip> : null}
                              </Paper>
                            </Grid>
                            <Grid container xs={12} justify="center">
                              <Button variant="outlined" color="secondary" style={{ marginRight: "10px" }} onClick={() => { this.applyFilter() }} className={classes.button} disabled={this.state.savedFilterData.length === 0} >Apply Filter</Button>
                            </Grid>
                          </Grid>
                        </form>
                      )}
                    </Formik>
                  </AccordionDetails>
                </Accordion>
                <Tabs value={this.state.selectedTabIndex} onChange={this._changeTab} indicatorColor="secondary" textColor="inherit" variant="scrollable" scrollButtons="auto">
                  <Tab label="Profiles" id="profilesTab" />
                  <Tab label="Transactions" id="transactionsTab" />
                  <Tab label="Agreements" id="agreementsTab" />
                </Tabs>
                <div role="tabpanel" hidden={this.state.selectedTabIndex !== 0} id={"profileTabPanel"} >
                  <Divider />
                  <Box style={{ padding: "0px", minHeight: "70vh", maxHeight: "70vh", }} >
                    <ProfileAdvancedSearchComponent searchValue={this.state.searchValue} />
                  </Box>
                </div>
                <div role="tabpanel" hidden={this.state.selectedTabIndex !== 1} id={"transactionTabPanel"} >
                  <Divider />
                  <Box style={{ padding: "0px", minHeight: "70vh", maxHeight: "70vh", }} >
                    <TransactionAdvancedSearchComponent searchValue={this.state.searchValue} />
                  </Box>
                </div>
                <div role="tabpanel" hidden={this.state.selectedTabIndex !== 2} id={"agreementTabPanel"} >
                  <Divider />
                  <Box style={{ padding: "0px", minHeight: "70vh", maxHeight: "70vh", }} >
                    <AgreementAdvancedSearchComponent searchValue={this.state.searchValue} />
                  </Box>
                </div>
              </DialogContent>
            </React.Fragment>
          </>
        );
      case ResultStatus.ERROR:
        return (
          <React.Fragment>
            <DialogContent>
              <DialogErrorFragmentComponent small classes={classes} description={this.state.errorInfo}
                onRetry={() => { this.fetchFilterData(); }} />
            </DialogContent>
          </React.Fragment>
        );
      default:
        return <></>;
    }
  }
}

export default LayoutService.getHocComponenet(AdvancedSearchComponent);